var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active && _vm.showMessage && (_vm.items.length === 0))?_c('div',{staticClass:"empty text-primary text-center mt-3"},[_vm._v("\n  "+_vm._s(_vm.message || 'No se encontraron publicaciones')+"\n  "),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b17b448","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/EmptyResultsMessage.vue
// module id = null
// module chunks = 